import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";

class FormPrintMasruf extends React.Component {
  render() {
    return (
      <>
        <ProductConsumer>
          {(value) => {
            const { JM_dataRaportyKoga, JM_name, JM_code } = value;

            const wakil = JM_dataRaportyKoga.filter((data) => {
              if (JM_name != "") {
                return data.nameofproduct
                  .toLowerCase()
                  .startsWith(JM_name.toLowerCase());
              } else if (JM_code != "") {
                return data.code.toString().startsWith(JM_code);
              } else {
                return data.rasidKarton > 0 && data;
              }
            }).map((user, i) => {
              return (
                <tr key={i} className="f4">
                  <td
                    className="fk"
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.6em",
                      color: "black"
                    }}
                  >
                    <NumberFormat
                      value={Number(
                        user.rasidKarton * user.numberOfDarzan * user.price
                      ).toFixed(2)}
                      displayType="text"
                      thousandSeparator={true}
                    />
                  </td>
                  <td
                    className="fk"
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.6em",
                      color: "black"
                    }}
                  >
                    {user.numberOfDarzan}
                  </td>
                  <td
                    className="fk"
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.6em",
                      color: "black"
                    }}
                  >
                    {user.price}
                  </td>
                  <td
                    className="fk"
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.6em",
                      color: "black"
                    }}
                  >
                    {Number(user.rasidKarton * user.numberOfDarzan).toFixed(2)}
                  </td>
                  <td
                    className="fk"
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.6em",
                      color: "black"
                    }}
                  >
                    {Number(user.rasidKarton).toFixed(2)}
                  </td>
                  <td
                    className="fk"
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.6em",
                      color: "black"
                    }}
                  >
                    {user.nameofproduct}
                  </td>
                  <td
                    className="fk"
                    className="fk"
                    style={{
                      borderBottom: "2px solid black",
                      borderTop: "2px solid black",
                      borderRight: "2px solid black",
                      borderLeft: "2px solid black",
                      fontSize: "1.6em",
                      color: "black"
                    }}
                  >
                    {user.code}
                  </td>
                </tr>
              );
            });

            return (
              <table id="example" className="table table-striped  text-right ">
                <thead>
                  <tr
                    className="text-black f4"
                    style={{ backgroundColor: "#2C3539" }}
                  >
                    <th
                      className="fk"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        fontSize: "1.6em",
                        color: "black"
                      }}
                    >
                      $ کۆی گشتی{" "}
                    </th>
                    <th
                      className="fk"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        fontSize: "1.6em",
                        color: "black"
                      }}
                    >
                      ڕێژە
                    </th>
                    <th
                      className="fk"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        fontSize: "1.6em",
                        color: "black"
                      }}
                    >
                      $ كڕین
                    </th>
                    <th
                      className="fk"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        fontSize: "1.6em",
                        color: "black"
                      }}
                    >
                      دەرزەن
                    </th>
                    <th
                      className="fk"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        fontSize: "1.6em",
                        color: "black"
                      }}
                    >
                      كارتۆنی ماوە
                    </th>
                    <th
                      className="fk"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        fontSize: "1.6em",
                        color: "black"
                      }}
                    >
                      ناوەی کاڵا
                    </th>
                    <th
                      className="fk"
                      style={{
                        borderBottom: "2px solid black",
                        borderTop: "2px solid black",
                        borderRight: "2px solid black",
                        borderLeft: "2px solid black",
                        fontSize: "1.6em",
                        color: "black"
                      }}
                    >
                      کۆد
                    </th>
                  </tr>
                </thead>
                <tbody>{wakil}</tbody>
              </table>
            );
          }}
        </ProductConsumer>
      </>
    );
  }
}
export default FormPrintMasruf;
